module.exports = __webpack_public_path__ + "assets/img/75@3x.13a4dc11.png";